import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { post, fetch, patch, put } from './http'
import VueCookie from 'vue-cookie'
import VueCountdownTimer from 'vuejs-countdown-timer'

Vue.prototype.$post = post
Vue.prototype.$fetch = fetch
Vue.prototype.$patch = patch
Vue.prototype.$put = put

Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(VueCookie)
Vue.use(VueCountdownTimer)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
